import { textFactory } from 'src/locale/textFactory'
import styles from './MainOurService.module.scss'
import MainOurServiceRoundBox from './MainOurServiceRoundBox'
import ThumbsUp from 'public/images/thumbs-up.svg'
import Video from 'public/images/video.svg'
import Puzzle from 'public/images/puzzle.svg'
import ButtonRoundWithHarpoon from 'src/components/shared/ButtonRoundWithHarpoon'
import { useContext, useMemo } from 'react'
import { LocaleContext } from 'src/contexts/contextapi'

export default function MainOurService() {
  const text = textFactory()
  const { locale } = useContext(LocaleContext)
  const codeitLink = useMemo(() => {
    switch (locale) {
      case 'en': return 'https://www.codeit.com'
      case 'ko': return 'https://www.codeit.kr'
    }
  }, [ locale ])
  return (
    <div className={ styles.MainOurService }>
      <div className={ styles.titleDescriptionBox }>
        <h2 className={ styles.title }>{ text.MainOurService_title }</h2>
        <p
          className={ styles.MainOurService__description }
          dangerouslySetInnerHTML={ { __html: text.MainOurService_description } }
        />
      </div>
      <div className={ styles.meritBox }>
        <MainOurServiceRoundBox
          className={ styles.MainOurService__merit }
          message={ text.MainOurService_satisfaction }
          badgeIcon={ <ThumbsUp className={ styles.icon }/> }
        />
        <MainOurServiceRoundBox
          className={ styles.MainOurService__merit }
          message={ text.MainOurService_content }
          badgeIcon={ <Video className={ styles.icon }/> }
        />
        <MainOurServiceRoundBox
          className={ styles.MainOurService__merit }
          message={ text.MainOurService_guide }
          badgeIcon={ <Puzzle className={ styles.icon }/> }
        />
      </div>
      <div className={ styles.spacer }/>
      <ButtonRoundWithHarpoon
        className={ styles.enterCodeit }
        message={ text.MainOurService_enter_codeit }
        onClick={ () => window.open(codeitLink) }
      />
      <div className={ styles.spacer2 }/>
    </div>
  )
}
